// Administrative plan choices; feature rollout and role authorization still
// apply separately. Native entries do not activate unimplemented workflows.
// The backend catalog is verified against these keys by the contract tests.
export const MODULE_CATALOG = [
  { key: 'canvas', icon: 'account_tree' },
  { key: 'email', icon: 'mail' },
  { key: 'whatsapp', icon: 'chat' },
  { key: 'documents', icon: 'description' },
  { key: 'costs', icon: 'receipt_long' },
  { key: 'projects', icon: 'folder' },
  { key: 'time', icon: 'timer' },
  { key: 'leads', icon: 'notifications_active' },
  { key: 'extraction', icon: 'document_scanner' },
  { key: 'finance', icon: 'account_balance' },
  { key: 'project_finance', icon: 'calculate' },
  { key: 'purchasing', icon: 'shopping_cart' },
];
